import { LineChart, Line, ResponsiveContainer, YAxis } from "recharts";
import { DOMAIN_RANGE } from "@/lib/chart";
import { useTicker, num, pct } from "@/lib/format";

const Spark = ({ data, up }) => (
  <ResponsiveContainer width="100%" height={44}>
    <LineChart data={data.map((v, i) => ({ i, v }))}>
      <YAxis hide domain={DOMAIN_RANGE} />
      <Line type="monotone" dataKey="v" stroke={up ? "#10B981" : "#EF4444"} strokeWidth={2} dot={false} isAnimationActive={false} />
    </LineChart>
  </ResponsiveContainer>
);

export const MarketPulse = () => {
  const { data, isLoading } = useTicker();
  const idx = data?.indices || [];
  const stocks = data?.stocks || [];
  return (
    <section data-testid="market-pulse" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-20">
      <div className="flex flex-wrap items-end justify-between gap-3 mb-8">
        <div>
          <p className="text-xs font-bold uppercase tracking-[0.18em] text-[#059669]">Market Pulse</p>
          <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-extrabold tracking-tight mt-2">How Indian markets are moving right now</h2>
        </div>
        <p className="text-xs text-slate-500">{data?.source} · auto-refresh every 60s</p>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {(isLoading ? Array(8).fill(null) : idx).map((q, i) => q ? (
          <div key={q.symbol} data-testid={`pulse-card-${i}`} className="bg-white rounded-2xl border border-slate-200 p-4 hover:shadow-md transition-shadow">
            <p className="text-xs font-semibold text-slate-500">{q.label}</p>
            <p className="font-mono text-lg sm:text-xl font-bold mt-1">{num(q.price)}</p>
            <p className={`font-mono text-xs font-semibold ${q.change_pct >= 0 ? "text-emerald-600" : "text-red-500"}`}>{q.change >= 0 ? "+" : ""}{num(q.change)} ({pct(q.change_pct)})</p>
            {q.spark?.length > 1 && <Spark data={q.spark} up={q.change_pct >= 0} />}
          </div>
        ) : <div key={i} className="h-36 rounded-2xl bg-slate-200/60 animate-pulse" />)}
      </div>
      {stocks.length > 0 && (
        <div className="mt-6 bg-[#1E293B] rounded-2xl p-5 text-white">
          <p className="text-xs font-bold uppercase tracking-wider text-amber-300 mb-3">Nifty heavyweights</p>
          <div className="grid grid-cols-2 sm:grid-cols-5 gap-x-6 gap-y-3">
            {stocks.map((s) => (
              <div key={s.symbol} className="flex items-baseline justify-between gap-2 font-mono text-sm">
                <span className="font-sans font-semibold text-slate-200 truncate">{s.label}</span>
                <span className={s.change_pct >= 0 ? "text-emerald-400" : "text-red-400"}>{pct(s.change_pct)}</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </section>
  );
};
